package pl.zar.tikthrow.util

fun currentAuthToken(): String? {
    return runCatching { createPostsSettings().getStringOrNull(AUTH_TOKEN_KEY) }.getOrNull()
}

const val AUTH_TOKEN_KEY: String = "auth_token"
